import { inject, DestroyRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
const siUnits = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
function readFileAsString(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = event => resolve(event.target?.result);
    reader.readAsText(file);
  });
}
function fileExtension(name) {
  const idx = name.lastIndexOf('.');
  if (idx === -1 || name.length - idx > 5) {
    return null;
  }
  return name.substring(idx + 1);
}
function loadImage(path) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = path;
    image.onload = resolve;
    image.onerror = reject;
    image.onabort = reject;
  });
}
function colorHexToNumber(str) {
  if (str.charAt(0) === '#') {
    str = str.substring(1);
  }
  return parseInt(str, 16);
}
function numberToColorHex(num) {
  return `#${num.toString(16).padStart(6, '0')}`;
}
function humanFileSize(bytes, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }
  const units = siUnits;
  let u = -1;
  const r = 10 ** dp;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  return bytes.toFixed(dp) + ' ' + units[u];
}
function untilDestroyed() {
  const subject = new Subject();
  inject(DestroyRef).onDestroy(() => {
    subject.next(true);
    subject.complete();
  });
  return () => takeUntil(subject.asObservable());
}

/**
 * Generated bundle index. Do not edit.
 */

export { colorHexToNumber, fileExtension, humanFileSize, loadImage, numberToColorHex, readFileAsString, untilDestroyed };
